import React from 'react';
import PropTypes from 'prop-types';

import { Link } from 'gatsby';
import { windowExists } from '../../utils/index';
import styles from './profile.module.scss';

function ProfileCard(props) {
  const {
    company,
    disableLink,
    image,
    jobTitle,
    link,
    name,
  } = props;

  const Tag = !disableLink && link ? Link : 'div';
  const backLink = windowExists ? window.location.pathname : '/';

  const internalUri = (link && link[0] === '/') ? link : `/${link}`;
  return (
    <div className={styles.card}>
      {image && (
        <div className={styles.imgContainer}>
          <Tag to={internalUri} state={{backLink: backLink}}>
            <img className={styles.image} src={image.file.url} alt={name} />
          </Tag>
        </div>
      )}

      <div className={styles.content}>
        {name && (
          <Tag to={internalUri} state={{backLink: backLink}}>
            <h4 className={styles.name}>{name}</h4>
          </Tag>
        )}

        {jobTitle && (
          <p className={styles.title}>{jobTitle}</p>
        )}

        {company && (
          <p className={styles.company}>{company}</p>
        )}
      </div>
    </div>
  );
}

export default ProfileCard;

ProfileCard.propTypes = {
  company: PropTypes.string,
  disableLink: PropTypes.bool,
  image: PropTypes.shape({
    file: PropTypes.shape({
      url: PropTypes.string,
    }),
  }),
  jobTitle: PropTypes.string,
  link: PropTypes.string,
  name: PropTypes.string,
};

ProfileCard.defaultProps = {
  company: '',
  disableLink: false,
  image: {
    file: {
      url: '',
    },
  },
  jobTitle: '',
  link: '',
  name: '',
};
